// extracted by mini-css-extract-plugin
export default {"topic":"LandingPageMain_topic__1JXIZ","journey":"LandingPageMain_journey__7uLtg","analytics":"LandingPageMain_analytics__8xu7d","mainCards":"LandingPageMain_mainCards__5Z099"};